import { render, staticRenderFns } from "./introduction.vue?vue&type=template&id=36ab4f9a&scoped=true&"
import script from "./introduction.vue?vue&type=script&lang=js&"
export * from "./introduction.vue?vue&type=script&lang=js&"
import style1 from "./introduction.vue?vue&type=style&index=1&id=36ab4f9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ab4f9a",
  null
  
)

export default component.exports